import { ProjectAnalysesSectionPage } from '@/pages/ProjectAnalysesSectionPage';

export function ProjectAnalysesConfortPage() {
  return <ProjectAnalysesSectionPage sectionTitle="Confort" />;
}

